<script setup lang="ts">
import { currency } from '@/helpers/current-price'
import { onMounted } from 'vue'
import { Input } from '../input'

const model = defineModel<string | number>()

onMounted(() => {
    if (model.value) {
        model.value = currency(String(model.value))
    }
})
</script>

<template>
    <div class="relative w-full items-center">
        <Input
            ref="inputRef"
            type="text"
            v-model="model"
            @input="(e: Event) => (model = currency((e.target as HTMLInputElement).value))"
            class="pl-11"
        />

        <span class="absolute inset-y-0 start-0 flex items-center justify-center px-4"> R$ </span>
    </div>
</template>
